import type { ChangeEvent } from "react";

export const INPUT_EVENT_TYPE = {
    insertText: "insertText",
    deleteContentBackward: "deleteContentBackward",
    deleteContentForward: "deleteContentForward",
} as const;

export const isManualInput = (e: ChangeEvent<HTMLInputElement>): boolean => {
    const native = e.nativeEvent as InputEvent;

    if (!native || !native.inputType) return false;

    // List of input types that we consider manual input
    const manualTypes: string[] = [
        INPUT_EVENT_TYPE.insertText, // regular manual input
        INPUT_EVENT_TYPE.deleteContentBackward,
        INPUT_EVENT_TYPE.deleteContentForward,
    ];

    return manualTypes.includes(native.inputType);
};